import React from 'react';
import { AND, OR } from "../../../misc/RuleObjectTypes";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";

/* And/Or between filter rows — DS Dropdown (okf/rules § 4.4), replacing a
   `form-select drop-down-dm` native select. `usePortal`: it lives inside the
   DS Dialog's overflow-y-auto content, the exact clip the Guide widget dialog
   hit. The dispatch payload is byte-compatible: the old select emitted the
   STRING form of the numeric constant (ev.target.value), so `String(value)`. */
const FilterOperator = ({ element, position, reduceFilters }) => {
  return (
    <div className="filter-op tw-w-28 tw-my-2">
      <Dropdown
        label=""
        aria-label="Filter operator"
        data-testid="rule-filter-operator-select"
        usePortal
        options={[
          { value: AND, label: "And" },
          { value: OR, label: "Or" },
        ]}
        value={Number(element.value)}
        onChange={(value) => {
          reduceFilters({
            type: "UPDATE_OP",
            position: position,
            value: String(value),
          });
        }}
      />
    </div>
  );
};
export default FilterOperator;
